import type { SiteVariant } from "@/context/VariantContext";

/**
 * Sets the layout variant cookie and reloads the page.
 *
 * Persists variant preference for 24 hours with SameSite=Lax for security.
 * Called when user switches between UK/US site variants.
 *
 * @param newVariant - The site variant to set ("uk" | "us")
 */
export const setVariantAndReload = (newVariant: SiteVariant): void => {
  const ukHost = "tony.uk";
  const usHost = "tony.nl";
  const hostname = window.location.hostname;
  const targetHost = newVariant === "uk" ? ukHost : usHost;

  if ((hostname === ukHost || hostname === usHost) && hostname !== targetHost) {
    const nextUrl = `${window.location.protocol}//${targetHost}${window.location.pathname}${window.location.search}${window.location.hash}`;
    window.location.assign(nextUrl);
    return;
  }

  // biome-ignore lint/suspicious/noDocumentCookie: Cookie Store API not widely supported; using document.cookie for variant persistence
  document.cookie = `layout=${newVariant}; path=/; max-age=86400; SameSite=Lax`;
  window.location.reload();
};
